export { default as getFileIcon } from './getFileIcon';
